export default __webpack_public_path__ + "static/media/hsycbh_white.d8568f86.svg";